import { sessionSearchFilterSlice } from '../SessionFilterSearchSlice'
import useSliceWrapper from './useSliceWrapper'

const useGetMethodsAndData = () => useSliceWrapper('sessionSearchFilter', sessionSearchFilterSlice)

export const useSessionSearchFilterSlice = (): ReturnType<typeof useGetMethodsAndData> =>
    useGetMethodsAndData()

export default useSessionSearchFilterSlice
